import { Link } from 'react-router-dom';

const CARDS = [
  {
    icon: '\uD83D\uDE4B',
    title: "I'm a Patient",
    desc: 'Book doctors, track health, order meds, manage NHIS',
    btn: 'Create Patient Account',
    href: '/register?role=patient',
  },
  {
    icon: '\uD83E\uDE7A',
    title: "I'm a Clinician",
    desc: 'See patients, AI-powered charting, automated billing',
    btn: 'Join as a Provider',
    href: '/register?role=clinician',
  },
  {
    icon: '\uD83C\uDFE5',
    title: "I'm a Facility",
    desc: 'Clinic or hospital management, NHIS, analytics',
    btn: 'Register Facility',
    href: '/register?role=facility',
  },
];

export default function CTASection() {
  return (
    <section className="cta-section">
      <h2>Start your health journey today.</h2>
      <p>
        Create your free account in minutes — and bring care, prescriptions, and your NHIS
        into one place, wherever you are in Ghana.
      </p>

      <div className="cta-grid">
        {CARDS.map((c) => (
          <Link to={c.href} className="cta-card" key={c.title}>
            <div className="cta-card-icon">{c.icon}</div>
            <div className="cta-card-title">{c.title}</div>
            <div className="cta-card-desc">{c.desc}</div>
            <span className="cta-card-btn">{c.btn}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
